import type { TextContent } from "@/lib/contentParsers/contentItemSchemas";
import { EditorSelectFieldView } from "@/features/sparxsEditor/components/molecules/form/EditorSelectFieldView";
import { EditorTextFieldView } from "@/features/sparxsEditor/components/molecules/form/EditorTextFieldView";
import { SectionFormShell } from "@/features/sparxsEditor/components/molecules/sectionFormShell/SectionFormShell";
import { toHideField } from "@/lib/sparxs/toHideField";
import { useFormPath } from "@/features/sparxsEditor/contexts/FormPathContext";
import { useEditorTitle } from "@/features/sparxsEditor/contexts/EditorTitleContext";
import { EDITOR_FIELD_HEADERS } from "@/constants/editorFieldHeaders";
import { CONTENT_PREVIEW_EDIT_WHITELIST } from "@/features/sparxsEditor/constants/contentPreviewEditWhitelist";

const FORM_LABEL_TITLE = "title";
const LABEL_TEXT = "Text";
const LABEL_FONT_SIZE = "fontSize";
export const FONT_SIZE = { REGULAR: "regular", LARGE: "large" } as const;

export interface TextSectionProperties {
  text: TextContent;
  id: string;
}

export const TextSectionView = ({
  text: { formLabel, text: textValue, fontSize },
  id,
}: TextSectionProperties) => {
  const name = useFormPath();
  const title = useEditorTitle();
  const isTitle = formLabel === FORM_LABEL_TITLE;
  const hideText = toHideField(`${name}.text`);
  const hideFontSize = toHideField(`${name}.fontSize`);

  return (
    <SectionFormShell
      formLabel={formLabel}
      header={isTitle ? EDITOR_FIELD_HEADERS.TITLE : EDITOR_FIELD_HEADERS.TEXT}
      noContainer
    >
      <EditorTextFieldView
        name={`${name}.text`}
        label={LABEL_TEXT}
        id={
          formLabel ? `${title}-text-${formLabel}-${id}` : `${title}-${id}-text`
        }
        defaultValue={textValue}
        toHide={hideText}
        className={isTitle ? "text-xl font-bold" : undefined}
      />
      <div>
        <EditorSelectFieldView
          option1={FONT_SIZE.REGULAR}
          option2={FONT_SIZE.LARGE}
          name={`${name}.fontSize`}
          label={LABEL_FONT_SIZE}
          id={formLabel ? `text-${formLabel}-fontSize` : `${id}-fontSize`}
          defaultValue={
            fontSize === FONT_SIZE.LARGE ? FONT_SIZE.LARGE : FONT_SIZE.REGULAR
          }
          disable={!CONTENT_PREVIEW_EDIT_WHITELIST.allowTextSectionFontSizeEdit}
          toHide={hideFontSize}
        />
      </div>
    </SectionFormShell>
  );
};
